import { render, staticRenderFns } from "./VNotAllowed.vue?vue&type=template&id=192026f1&scoped=true&"
import script from "./VNotAllowed.vue?vue&type=script&lang=js&"
export * from "./VNotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192026f1",
  null
  
)

export default component.exports